/*
 * File: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_frontoffice\src\Utils\common.utils.ts
 * Project: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_frontoffice
 * Created Date: Wednesday August 28th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Wednesday August 28th 2024 9:40:40 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

export const formatSiren = (value: string) => {
    const cleanedValue = value.replace(/\s+/g, '');
    const part1 = cleanedValue.slice(0, 9).replace(/(\d{3})(?=\d)/g, '$1 ').trim();
    return `${part1}`.trim();
};
